import { useEffect, useState } from "react";
import { Reveal } from "../components/Reveal";
import { useModal } from "../context/ModalContext";
import { useSettings } from "../context/SettingsContext";
import { api } from "../lib/api";
import { Check, Star, Phone } from "lucide-react";

export function Pricing() {
  const [pkgs, setPkgs] = useState([]);
  const { open } = useModal();
  const { settings } = useSettings();

  useEffect(() => { api.get("/pricing").then((r) => setPkgs(r.data)).catch(() => {}); }, []);

  return (
    <section id="pricing" className="section-pad bg-neutral-50" data-testid="pricing-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal className="text-center">
          <span className="overline">Pricing</span>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">
            Simple, honest <span className="brand-text">pricing</span>
          </h2>
          <p className="mt-4 text-neutral-500 max-w-xl mx-auto">No hidden charges. Flexible lesson timings. Block-booking value with everything you need to pass.</p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {pkgs.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1}>
              <div className={`relative card-soft p-8 h-full flex flex-col ${p.popular ? "ring-2 ring-brand-orange shadow-soft-lg" : ""}`} data-testid={`pricing-${p.id}`}>
                {p.popular && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 brand-gradient text-white text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full flex items-center gap-1">
                    <Star size={12} className="fill-white" /> Most Popular
                  </span>
                )}
                <h3 className="font-heading text-xl font-bold">{p.name}</h3>
                <p className="text-sm text-neutral-500">{p.tagline}</p>
                <div className="mt-5">
                  <p className="text-xs font-semibold uppercase tracking-wider text-neutral-400">10-Lesson Block</p>
                  <div className="flex items-end gap-2 mt-1">
                    <span className="font-heading text-5xl sm:text-6xl font-extrabold tracking-tight brand-text">{p.currency}{p.price}</span>
                  </div>
                  <div className="mt-3 flex flex-wrap gap-2 text-xs">
                    <span className="rounded-full bg-neutral-100 text-neutral-700 font-semibold px-3 py-1">{p.currency}{p.per_lesson || ""} / {p.duration || "50 min"} lesson</span>
                    <span className="rounded-full brand-gradient text-white font-semibold px-3 py-1">1st lesson {p.currency}{p.first_lesson || "14.95"}</span>
                    <span className="rounded-full bg-green-100 text-green-700 font-semibold px-3 py-1">Free Theory Tuition</span>
                  </div>
                </div>
                <ul className="mt-6 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-sm">
                      <span className="w-5 h-5 rounded-full bg-green-100 text-green-600 flex items-center justify-center shrink-0"><Check size={13} strokeWidth={3} /></span>
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="mt-7 flex flex-col gap-2">
                  <button className={p.popular ? "btn-primary" : "btn-dark"} onClick={() => open("booking", { package: p.name, lesson_type: p.name.includes("Automatic") ? "Automatic" : "Manual" })} data-testid={`book-${p.id}`}>Book Now</button>
                  <div className="flex gap-2">
                    <button className="btn-outline flex-1 !py-2.5 text-sm" onClick={() => open("quote", { lesson_type: p.name.includes("Automatic") ? "Automatic" : "Manual" })} data-testid={`quote-${p.id}`}>Get Quote</button>
                    <a href={`tel:${settings.phone_link || ""}`} className="btn-outline flex-1 !py-2.5 text-sm" data-testid={`call-${p.id}`}><Phone size={15} /> Call</a>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="text-center text-sm text-neutral-400 mt-8">No hidden charges · Flexible lesson timings · Payment by bank transfer or cash</p>
      </div>
    </section>
  );
}
